import { Deserializable } from './deserializable.model';

export class Projection implements Deserializable {
  public avg_rank: number;
  public bye_week: number;
  public fantasy_points: number;
  public fantasy_points_rank: number;
  public fumbles: number;
  public fumbles_lost: number;
  public games: number;
  public player_id: number;
  public player_name: string;
  public position: string;
  public recv_recaptions: number;
  public recv_target: number;
  public recv_td: number;
  public recv_yds: number;
  public rush_att: number;
  public rush_td: number;
  public rush_yds: number;
  public team_name: number;
  public ranks: any;
  public pos_rank: number;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}